module.exports = __webpack_public_path__ + "assets/33.jpg?1121ddf517575b4a1249721ede9db926";